var ADOLOPMENT_OPTIONS, BOOLEAN_OPTIONS, BOOLEAN_OPTIONS_WITH_NOT_REPORTED, CERTAINTIES_OF_EVIDENCE, CHRONIC_PAIN_AGE, CHRONIC_PAIN_COMPARATORS, CHRONIC_PAIN_EQUITY_CONSIDERATIONS, CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS, CHRONIC_PAIN_INTERVENTIONS, CHRONIC_PAIN_PICO_FORM, CHRONIC_PAIN_POPULATIONS, CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS, CHRONIC_PAIN_RECOMMENDATION_INTENTS, COUNTRIES, GRADING_OPTIONS, LANGUAGES, PlainLanguageLinksField, RECOMMENDATION_STRENGTHS, SECOND_WORLD_REGION_OPTIONS, TYPES_OF_ORGANIZATION, USERS_OPTIONS, WORLD_REGIONS, _ref;

PlainLanguageLinksField = require('components/covid_extraction_form/plain_language_links_field');

_ref = require('lib/extraction_form_helper'), ADOLOPMENT_OPTIONS = _ref.ADOLOPMENT_OPTIONS, BOOLEAN_OPTIONS = _ref.BOOLEAN_OPTIONS, BOOLEAN_OPTIONS_WITH_NOT_REPORTED = _ref.BOOLEAN_OPTIONS_WITH_NOT_REPORTED, CERTAINTIES_OF_EVIDENCE = _ref.CERTAINTIES_OF_EVIDENCE, COUNTRIES = _ref.COUNTRIES, GRADING_OPTIONS = _ref.GRADING_OPTIONS, LANGUAGES = _ref.LANGUAGES, RECOMMENDATION_STRENGTHS = _ref.RECOMMENDATION_STRENGTHS, SECOND_WORLD_REGION_OPTIONS = _ref.SECOND_WORLD_REGION_OPTIONS, TYPES_OF_ORGANIZATION = _ref.TYPES_OF_ORGANIZATION, WORLD_REGIONS = _ref.WORLD_REGIONS;

USERS_OPTIONS = _.map(["healthCareProfessional", 'patientAndCaregiver', 'policymaker'], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.users." + value)
  };
});

CHRONIC_PAIN_RECOMMENDATION_INTENTS = _.map(['dosing', 'tapering', 'rotating', 'riskMitigation'], function(value) {
  return {
    value: value,
    text: $.t("es:recommendations.metadataExtractionForm.values.recommendationIntent." + value)
  };
});

CHRONIC_PAIN_AGE = _.map(["any", "child", "adult", "adultUnspecified", "olderAdult"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.chronicPain.age." + value)
  };
});

CHRONIC_PAIN_INTERVENTIONS = _.map(["opioids", "cannabis", "spineRelatedInterventionalProcedures"], function(value) {
  return {
    id: uuid.v5(value, uuid.NIL),
    selected: false,
    value: $.t("settings:general_information.values.chronicPain.interventions." + value)
  };
});

CHRONIC_PAIN_COMPARATORS = _.map(["opioid", "cannabis", "spine_related_interventional_procedures", "opioid_plus_usual_care", "cannabis_plus_usual_care ", "spine_related_interventional_procedures_plus_usual_care", "usual_care"], function(value) {
  return {
    id: uuid.v5(value, uuid.NIL),
    selected: false,
    value: $.t("settings:general_information.values.chronicPain.comparators." + value)
  };
});

CHRONIC_PAIN_POPULATIONS = _.map(["chronicNonCancerPain", "chronicCancerPain", "peopleReceivingPalliativeCare", "children", "pregnantPeople", "veterans", "comorbidMentalIllness"], function(value) {
  return {
    id: uuid.v5(value, uuid.NIL),
    selected: false,
    value: $.t("settings:general_information.values.chronicPain.population." + value)
  };
});

CHRONIC_PAIN_EQUITY_CONSIDERATIONS = _.map(["seniors", "lowIncomeAndUnstablyHousedIndividuals", "thoseWithMentalHealthOrSubstanceUseChallenges", "indigenousAndRacializedCommunities", "veterans", "tradesWorkers", "survivorsOfViolence", "personsWithDisabilities", "genderDiversePeople", "women", "other"], function(value) {
  return {
    value: value,
    text: $.t("settings:general_information.values.equityConsiderations." + value)
  };
});

CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS = {
  agree: [
    {
      fieldKey: 'scopeAndPurpose',
      type: 'percent'
    }, {
      fieldKey: 'stakeholderInvolvement',
      type: 'percent'
    }, {
      fieldKey: 'rigorOfDevelopment',
      type: 'percent'
    }, {
      fieldKey: 'clarityOfPresentation',
      type: 'percent'
    }, {
      fieldKey: 'applicability',
      type: 'percent'
    }, {
      fieldKey: 'editorialIndependence',
      type: 'percent'
    }, {
      fieldKey: 'scorePassed',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS,
      infoText: true
    }
  ],
  main: [
    {
      fieldKey: 'guidelineNoId',
      type: 'text'
    }, {
      fieldKey: 'title',
      type: 'text'
    }, {
      fieldKey: 'authors',
      type: 'text'
    }, {
      fieldKey: 'guidelineLanguage',
      type: 'select',
      options: LANGUAGES
    }, {
      fieldKey: 'fullReference',
      type: 'text'
    }, {
      fieldKey: 'publicationDate',
      type: 'date'
    }, {
      fieldKey: 'source',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'organizationType',
      type: 'multiSelect',
      options: TYPES_OF_ORGANIZATION
    }, {
      fieldKey: 'sourceDocumentLink',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'whoIrisId',
      type: 'text'
    }, {
      fieldKey: 'isbn',
      type: 'text'
    }, {
      fieldKey: 'doi',
      type: 'text'
    }, {
      fieldKey: 'pmid',
      type: 'text'
    }, {
      fieldKey: 'fundingBody',
      type: 'text'
    }, {
      fieldKey: 'guidelineGroupDetails',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'declarationOfInterestChronicPain',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS,
      withOther: true
    }, {
      fieldKey: 'declarationOfInterestManaged',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS,
      withOther: true
    }, {
      fieldKey: 'country',
      type: 'multiSelect',
      options: COUNTRIES
    }, {
      fieldKey: 'latestLiteratureSearchDate',
      type: 'date'
    }, {
      fieldKey: 'gradingEvidenceMethod',
      type: 'radioOptions',
      options: GRADING_OPTIONS,
      placeholderFromI18n: true,
      withOther: true
    }
  ],
  codes: [
    {
      fieldKey: 'guidelineInterventions',
      type: "codesWithCheckboxes",
      options: CHRONIC_PAIN_INTERVENTIONS,
      additionalProps: {
        hideLabel: true
      }
    }, {
      fieldKey: 'guidelinePopulations',
      type: "codesWithCheckboxes",
      options: CHRONIC_PAIN_POPULATIONS,
      additionalProps: {
        hideLabel: true
      }
    }
  ],
  progress: [
    {
      fieldKey: 'users',
      type: 'multiSelect',
      options: USERS_OPTIONS
    }, {
      fieldKey: 'secondWorldRegionCategory',
      type: 'multiSelect',
      options: SECOND_WORLD_REGION_OPTIONS
    }, {
      fieldKey: 'worldRegion',
      type: 'multiSelect',
      options: WORLD_REGIONS
    }, {
      fieldKey: 'guidelineUpdatePlans',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS_WITH_NOT_REPORTED
    }, {
      fieldKey: 'equityConsiderations',
      type: 'multiSelectWithOther',
      options: CHRONIC_PAIN_EQUITY_CONSIDERATIONS
    }, {
      fieldKey: 'researchPriorities',
      type: 'text'
    }
  ]
};

CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS = {
  main: [
    {
      fieldKey: 'agreeRexDomains',
      type: 'percent'
    }, {
      fieldKey: 'age',
      type: 'multiSelect',
      options: CHRONIC_PAIN_AGE
    }, {
      fieldKey: 'recommendationIntent',
      type: 'multiSelect',
      options: CHRONIC_PAIN_RECOMMENDATION_INTENTS
    }, {
      fieldKey: 'publicationDate',
      type: 'date'
    }, {
      fieldKey: 'authors',
      type: 'editorText'
    }, {
      fieldKey: 'coexistingCondition',
      type: 'text',
      placeholderFromI18n: true,
      helperTextFromI18n: true
    }, {
      fieldKey: 'informal',
      type: 'switcher'
    }, {
      fieldKey: 'research',
      type: 'switcher'
    }, {
      fieldKey: 'adolopment',
      type: 'select',
      options: ADOLOPMENT_OPTIONS
    }, {
      fieldKey: 'transformed',
      type: 'switcher'
    }, {
      fieldKey: 'gradingEvidenceMethod',
      type: 'radioOptions',
      options: GRADING_OPTIONS,
      placeholderFromI18n: true,
      withOther: true
    }, {
      fieldKey: 'sofSupplemented',
      type: 'switcher'
    }, {
      fieldKey: 'etdModified',
      type: 'switcher'
    }, {
      fieldKey: 'certaintyOfEvidence',
      type: 'selectWithOther',
      options: CERTAINTIES_OF_EVIDENCE,
      placeholderFromI18n: true
    }, {
      fieldKey: 'certaintyOfEvidenceTextInput',
      type: 'editorText'
    }, {
      fieldKey: 'strengthOfRecommendation',
      type: 'selectWithOther',
      options: RECOMMENDATION_STRENGTHS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'strengthOfRecommendationText',
      type: 'editorText'
    }, {
      fieldKey: 'relatedRecommendationLinks',
      type: 'custom',
      customWithArray: true,
      component: PlainLanguageLinksField,
      showClear: false,
      additionalProps: {
        addBtnLabel: $.t('/actions.add_related_recommendation')
      }
    }, {
      fieldKey: 'equityItem2',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS,
      placeholderFromI18n: true
    }
  ]
};

CHRONIC_PAIN_PICO_FORM = {
  main: [
    {
      fieldKey: 'population',
      type: 'codesWithCheckboxes',
      options: CHRONIC_PAIN_POPULATIONS,
      additionalProps: {
        hideLabel: true
      }
    }, {
      fieldKey: 'intervention',
      type: 'codesWithCheckboxes',
      options: CHRONIC_PAIN_INTERVENTIONS,
      additionalProps: {
        hideLabel: true
      }
    }, {
      fieldKey: 'comparator',
      type: 'codesWithCheckboxes',
      additionalProps: {
        hideLabel: true
      }
    }, {
      fieldKey: 'outcome',
      type: 'codesWithCheckboxes',
      additionalProps: {
        hideLabel: true
      }
    }
  ]
};

module.exports = {
  CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS: CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS,
  CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS: CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS,
  CHRONIC_PAIN_PICO_FORM: CHRONIC_PAIN_PICO_FORM
};
